import React from "react";
import { styled } from "@mui/material/styles";

const ProfileImage = styled("img")({
  height: "50px",
  width: "50px",
});

export default ProfileImage;
